import AP from "../legacy/global";
import { getApiUrl } from "../utils/get-api-url";

export const getAccountManagers = async () => {
  const authString = AP.getAuthString();
  const apiUrl = getApiUrl("quotesapi");
  const fullUrl = `${apiUrl}/contacts/accountManagers`;
  const response = await fetch(fullUrl, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
      Authorization: authString,
      "X-Authorization": authString,
      "include-password": "true"
    },
    credentials: "include",
    method: "GET"
  });
  const json = await response.json();

  if (!response.ok) throw response.statusText;

  return json;
};
